/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
jQuery(document).ready(function ($) {
  jQuery(function () {
        jQuery(".review-item").each(function (i) {
            len = jQuery(this).text().length;
            if (len > 80) {
                jQuery(this).text(jQuery(this).text().substr(0, 80) + '...');
            }
        });
    jQuery("#google-reviews").googlePlaces({
        // placeId: 'ChIJgZKZ-khbeEgR4NGDPVTBOmk' //Find placeID @: https://developers.google.com/places/place-id
        placeId: 'ChIJI1tcwhWze0gRbWrbr8ntFdc' //Find placeID @: https://developers.google.com/places/place-id
        , render: ['reviews']
        , max_rows: 3
    });
  })
});
